import { observer } from 'mobx-react-lite';
import React from 'react';
import { TabPanel } from 'react-tabs';
import { colors } from '../../../../../../../../colorVars';
import { modifySoftOrder } from '../../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/modifySoftOrders';
import { updatePlugins } from '../../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/updatePlugins';
import { useWebsocketStore } from '../../../../../../../../stores/websocketStore/websocketProvider';
import { EditableTableField } from '../../../../../../../atomic/inputs/editableTableField/EditableTableField';
import { Body3 } from '../../../../../../../atomic/text/Text';
import { IndividualPanelHeader } from '../IndividualPanelHeader';
import style from '../IndividualTacticStyle.module.css';

export const PreserveProfitTacticPanel = observer(
  // eslint-disable-next-line no-unused-vars
  ({ tradePlanId, softOrderId, addTab, ...rest }) => {
    const { tradePlanStore } = useWebsocketStore();
    const tradePlan = tradePlanStore.tradePlans[tradePlanId];
    const tacticId = tradePlan.exitTactics['PRESERVE_PROFIT']?.tacticId ?? null;
    const inPosition = tradePlan?.inPosition ?? null;
    const softOrder = tradePlanStore.softOrdersById[tacticId] ?? null;

    const updateSoftOrder = (type, value) => {
      modifySoftOrder({ softOrder, type, value });
    };

    const updateTactic = (field, newValue) => {
      updatePlugins(
        'tactic',
        { [field]: newValue },
        'PRESERVE_PROFIT',
        tradePlanId,
        null
      );
    };
    if (!tradePlan?.exitTactics['PRESERVE_PROFIT']) return null;
    return (
      <TabPanel {...rest}>
        <div className={style.tableContainer}>
          <table className={style.table}>
            <IndividualPanelHeader />
            {inPosition && softOrder ? (
              <tbody>
                <tr>
                  <td className={style.labelTd}>
                    <Body3 fontWeight={700} color={colors.lightGrey}>
                      Preserve Amount
                    </Body3>
                  </td>
                  <td className={style.inputTd}>
                    <Body3
                      fontWeight={700}
                      color={colors.lightGrey}
                      margin="3px 3px 0 0"
                    >
                      $
                    </Body3>
                    <EditableTableField
                      inputType="number"
                      bodySize={3}
                      initialValue={softOrder.value.tacticValue.amount}
                      updateValue={(newValue) =>
                        updateSoftOrder('amount', newValue)
                      }
                      color={colors.lightGrey}
                      backgroundColor="inherit"
                    />
                  </td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            ) : (
              <tbody>
                <tr>
                  <td className={style.labelTd}>
                    <Body3 fontWeight={700} color={colors.lightGrey}>
                      Activation Amount
                    </Body3>
                  </td>
                  <td className={style.inputTd}>
                    <Body3
                      fontWeight={700}
                      color={colors.lightGrey}
                      margin="3px 3px 0 0"
                    >
                      $
                    </Body3>
                    <EditableTableField
                      inputType="number"
                      bodySize={3}
                      initialValue={
                        tradePlan.exitTactics['PRESERVE_PROFIT'].activationProfitAmount
                      }
                      updateValue={(newValue) =>
                        updateTactic('activationProfitAmount', newValue)
                      }
                      color={colors.lightGrey}
                      backgroundColor="inherit"
                    />
                  </td>
                  <td className={style.labelTd}>
                    <Body3 fontWeight={700} color={colors.lightGrey}>
                      Preserve Amount
                    </Body3>
                  </td>
                  <td className={style.inputTd}>
                    <Body3
                      fontWeight={700}
                      color={colors.lightGrey}
                      margin="3px 3px 0 0"
                    >
                      $
                    </Body3>
                    <EditableTableField
                      inputType="number"
                      bodySize={3}
                      initialValue={
                        tradePlan.exitTactics['PRESERVE_PROFIT'].amount
                      }
                      updateValue={(newValue) =>
                        updateTactic('amount', newValue)
                      }
                      color={colors.lightGrey}
                      backgroundColor="inherit"
                    />
                  </td>
                </tr>
              </tbody>
            )}
          </table>
        </div>
      </TabPanel>
    );
  }
);

PreserveProfitTacticPanel.tabsRole = 'TabPanel';
